import Model from 'modules/reports/orm/Model'

export default class Group extends Model {
  id: number
  name: string
}
